import type { Color } from "$lib/componentTypes";

class ToastStore {
  color: Color | null = $state(null);
  message: string | null = $state(null);
  isOpen = $state(false);
  showToast(color: Color, message: string, autohide = true) {
    this.color = color;
    this.message = message;
    this.isOpen = true;

    if (autohide) {
      setTimeout(() => {
        this.hideToast();
      }, 5000);
    }
  } 
  hideToast() {
    this.color = null;
    this.message = null;
    this.isOpen = false;
  }
}

export const toast = new ToastStore();